jQuery(function ($) {
  let modalTriggered = sessionStorage.getItem('modalTriggered') === 'true';
  let brochureUrl = null;

  function isInViewportMidToTop(el) {
    const rect = el.getBoundingClientRect();
    const triggerPoint = window.innerHeight * 0.6;
    return rect.top < triggerPoint && rect.bottom > 0;
  }

  function checkModalTrigger() {
    if (!modalTriggered && isInViewportMidToTop(document.querySelector('.contact-us-section'))) {
      setTimeout(function () {
        if (!modalTriggered) {
          $('.modal-black').addClass('active');
          modalTriggered = true;
          sessionStorage.setItem('modalTriggered', 'true');
        }
      }, 3000);
    }
  }

  $(window).on('scroll', checkModalTrigger);
  checkModalTrigger();

  $(document).on('click', '.modal-opener', function (e) {
    e.preventDefault();

    const $btn = $(this);

    if ($btn.hasClass('button-green')) {
      const downloadUrl = $btn.data('download-url');

      if (downloadUrl) {
        brochureUrl = downloadUrl;
        $('.modal-white').addClass('active');
      } else {
        $('.modal-black').addClass('active');
      }
    } else {
      $('.modal-black').addClass('active');
    }

    const $activeModal = $('.modal-white.active, .modal-black.active');
    if (window.innerWidth <= 1024 && $activeModal.length) {
      $('html, body').animate({
        scrollTop: $activeModal.offset().top - 60
      }, 600);
    }
  });

  $(document).on('click', '.modal-black, .modal-white', function (e) {
    if (!$(e.target).closest('.modal-container').length) {
      $('.modal-black, .modal-white').removeClass('active');
    }
  });

  $('.modal-close').on('click', function (e) {
    e.preventDefault();
    $('.modal-black, .modal-white').removeClass('active');
  });

  document.addEventListener('wpcf7mailsent', function (e) {
    if ($('.modal-white').hasClass('active') && brochureUrl) {
      $('.modal-white').removeClass('active');

      window.open(brochureUrl, '_blank');

      brochureUrl = null;
    }
  }, false);
});
